import script from "./AdminPriceList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPriceList.vue?vue&type=script&setup=true&lang=js"

import "./AdminPriceList.vue?vue&type=style&index=0&id=9c3a8f1c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c3a8f1c"]])

export default __exports__